<template>
    <div class="container">
        <img class="logo-pastel2" alt="pastel logo" src="../assets/logo-pastel.png">
        <h1 class="title">Pasteleria LaunchX</h1>
    </div>
</template>

<script>

export default {
  name: 'ImgLogo2',
}
</script>

<style>
    .logo-pastel2 {
        border-radius: 50%;
        width: 250px;
        align-self: flex-start;
        margin-left: 1%;
    }

    .container {
        display: flex;
    }

    .title {
        font-size: 75px;
        margin-left: 10%;
        margin-top: 4%;
    }
</style>>
